import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin"; 
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";


import Loading from "../../Loading/Loading";
import Snackbar from "../../../Snackbar";
import { createLabelsByApp } from "../../../store/actions/CreateCourse/createCourseByAdmin";
const TypeLabels = ({setActiveCardOverview,baseUrl})=>{
    const history = useHistory();
   
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
   const showSnackbar = () => {
    setSnackbarVisible(true);
  };
  
   const hideSnackbar = () => {
    setSnackbarVisible(false);
  };
  const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorTextDirection='left',CursorText) =>
  {
    
    dispatch({type: "CURSORTEXTDIRECTION",payload:CursorTextDirection  });
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    dispatch({type: "CURSORTEXTDIRECTION",payload:""  });
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
  ;
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);


const courseData = useSelector((state)=>state?.course?.course);

 const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"typeLabel":"");

 const [loader , setLoader] =useState({status:false});
 const [animate, setAnimate] = useState(false);
 const [itemDiffLevel , setItemDiffLevel] =useState([])
 const [selectedNameId , setSelectedNameId] =useState(null)
 
 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"":"Course";

 
 useEffect(() => {
    
    setItemDiffLevel(courseData?.typeLabel?JSON.parse(courseData?.typeLabel):"")
    setSelectedNameId(courseData?.typeLabel?JSON.parse(courseData?.typeLabel)?.ID:"")

   const timer = setTimeout(() => {
    setAnimate(true);  getCourseDifficultyLevels();
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);


  useEffect(()=>{
    setActiveCardOverview(true);
    
    // setCourseTitleData();
  },[])
   
     const handleCourseDiffLevel=(itemDiffLable)=>{
     
     
     
     setLoader({status:true});
     
       const apiData = dispatch(createCourseByAdminV2({typeLabel:JSON.stringify(itemDiffLable),
        type:courseData?.ID?courseData?.type:"course",
        postParent:"0" ,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:editType,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){
           if(response?.course){
             
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
       
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
    //    setItemArr(JSON.parse(response?.course?.typeLabel));
       setProductID(response?.course?.postId);
      setEditType("typeLabel")
    //   setGoNextPopUp(true);
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
        


    

       const defaultTitles =['Online Blended', 'Recorded', 'Live', 'Offline'];

    
  
const getCourseDifficultyLevels=(e)=>{

    setLoader({status:true});
      const user = dispatch(createLabelsByApp({categoryType:"typeLabels",
        newCategory:"",
        postParent:"0" ,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"setLabels",actionType:"edit",editLabelId:"",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken
    }));
      /* get response as Promise   */
      user.then(response => {
        if(response){
            // console.log(response)
        setItemDiffLevel(response?.category)
      
      
      }else{
      
        
          setResponseMessage("Something Went Wrong!!!");
        setSnackbarColor("rgb(218, 143, 143) ");
        }
    
  setLoader({status:false});
      }).catch(error => {
     
  setLoader({status:false});
        //popup of error Info
        setResponseMessage("Something Went Wrong!!!");
        setSnackbarColor("rgb(218, 143, 143) ");
    // setLoader({status:false});
        console.error(error);
      });
     
      }




        
const handleBack=(e)=>{
  
    setLoader({status:true});
    
    history.goBack();
    }
    
    

      const flattenedData =  itemDiffLevel&& itemDiffLevel!=[]?Object.values(itemDiffLevel):'';

    return <>
    
{<Loading  Load={loader?.status}/>}
    {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"><div  className="contentPageScroller"style={{zIndex:99999,borderRadius:"25px"} }>
 
   
<div>

<div  className=" ">
<div>      
     
      
    </div>
   <h1 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Set  <span className="coloredTextV1" >{TypeTitle} Type </span>  </h1>
   
<div  className="ikcraft_login-input-card"style={{
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease',
   }}>

<div class="input-card-outer">
                                 
                                 <div class="input-card-radio-two">
                                 {flattenedData?flattenedData.map((item, index) => 
        (<div className= {defaultTitles.includes(item?.post_title)?"input-card-radio-two-item-default":"input-card-radio-two-item"}  index={index} key={item.id} 
        style={{background:"#f9f9f9",borderRadius:"25px",padding:"5px"}}   >  <label onMouseEnter={
            ()=>handleMouseEnter("#fff","#333","","")}
onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                    
                       <div >{item?.post_title}</div> 
                    
                             <input type="radio" title={item?.post_title}  
checked={selectedNameId==item?.ID?"yes":""} 
                              className="input-textbox"  value={item?.ID}  name={item?.post_title}  
onChange={e=>{
    handleCourseDiffLevel(item)
    setSelectedNameId(e.target.value)
}

}

onClick={e=>{
    handleCourseDiffLevel(item)
setSelectedNameId(e.target.value)

}

}
/>
                                <span class={"boxCardBorder"}></span>
                       </label>
                      
                     
                       </div>)):""
        } 
                         
 </div>
 
 
  </div> 
 

</div>
   

 
</div>






</div>
<div style={{height:"70px"}}>
<button onMouseEnter={()=>handleMouseEnter("#fd5c63","#fff","")}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleBack()}}  className="CreateCourseStepsOuterRightButtonBackPopUp"  type="submit"
     id="signupBtn"> Back </button>
 {<button onMouseEnter={()=>handleMouseEnter("#fd5c63","#fff","")}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/status`)}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButtonPopUp"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save And Next"} </button>}
 
</div>
 
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 
 <div></div>
      
  </div></div>
</>

}
export default TypeLabels;